import Axios from "axios";
import IpService from "services/ipService";

/**
 * @typedef {Object} Config
 * @property {string} accessToken
 * @property {string} [apiVersion]
 * @property {string} [userIp]
 *
 * @param {Config} config
 * @param {string} contentType
 */
const InitApi = async (config, contentType = "application/json") => {
	const { accessToken, apiVersion = "v1", userIp } = config;

	const baseURL = `${process.env.REACT_APP_API_BASE_URL}/${apiVersion}`;

	let headers = {
		Accept: "application/json",
		"Content-Type": contentType,
	};

	// Add user IP header if provided, otherwise try to get it
	let detectedUserIp = userIp;
	if (!detectedUserIp) {
		try {
			detectedUserIp = await IpService.getUserIp();
		} catch (error) {
			console.warn("Could not detect user IP for API request:", error.message);
		}
	}

	if (detectedUserIp) {
		headers["X-User-Ip"] = detectedUserIp;
	}

	// 1000000 ms = 1000 s = 1 min

	const instance = Axios.create({
		baseURL,
		timeout: 1000000,
		withCredentials: false,
		headers: {
			...headers,
			Authorization: `Bearer ${accessToken}`,
		},
	});

	return instance;
};

export default InitApi;
